import { emailRegExp, trimText } from 'utils';
import localization from '../localization';
import { validatePhoneNum, validateName } from '../utils';

export default {
  employerName: {
    isValid: (name) => validateName(name),
    message: (lang) => localization[lang].common_errors.name
  },
  supervisorName: {
    isValid: (name) => validateName(name),
    message: (lang) => localization[lang].employment_errors.supervisor_name
  },
  monthlyIncome: {
    isValid: (name) => trimText(String(name)).length > 1,
    message: (lang) => localization[lang].employment_errors.monthly_income
  },
  durationOfEmployment: {
    isValid: (name) => trimText(name).length > 1,
    message: (lang) => localization[lang].employment_errors.employment_duration
  },
  plainAddress: {
    isValid: (name) => trimText(name).length > 1,
    message: (lang) => localization[lang].residency_errors.address,
  },
  address: {
    address: {
      isValid: (name) => trimText(name).length > 1,
      message: (lang) => localization[lang].residency_errors.address
    },
    city: {
      isValid: (name) => trimText(name).length > 1,
      message: (lang) => localization[lang].residency_errors.city
    },
    state: {
      isValid: (name) => trimText(name).length > 1,
      message: (lang) => localization[lang].residency_errors.state
    },
    zip: {
      isValid: (name) => trimText(name).length > 1,
      message: (lang) => localization[lang].residency_errors.zip
    }

  },
  email: {
    isValid: (email) => emailRegExp(trimText(email)),
    message: (lang) => localization[lang].employer_email_error
  },
  phoneNumber: {
    isValid: (num) => validatePhoneNum(trimText(num)),
    message: (lang) => localization[lang].common_errors.phone
  }
};
